import {FormControl, FormHelperText, Grid, IconButton, Stack, Typography} from "@mui/material"
import PropTypes from "prop-types"
import React, {useMemo} from "react"
import {getOptions} from "../../../misc/widget-functions"
import {PencilLineIcon} from "lucide-react"
import _ from "lodash"
import ButtonSelectWidgetItem from "./ButtonSelectWidgetItem"


const ButtonSelectWidget = ({
                                widget,
                                value,
                                onValueChange,
                                disabled,
                                triggerAction,
                            }) => {
    const options = useMemo(() => getOptions(widget), [widget])

    const onButtonClick = (optionValue) => {
        const newValue = options.find((option) => option.value === optionValue)

        if (onValueChange && newValue) {
            onValueChange(newValue.value)
        }
    }

    const onQuestionaireClick = (option) => triggerAction("OPEN_QUESTIONAIRE", option)
    return (
        <FormControl fullWidth variant="filled">
            {widget.text && <Typography component="label" variant="label" mb="4px">
                {widget.text}
            </Typography>}
            <Stack spacing={2}>
                {_.isArray(options) && options.map(option => <Grid key={option?.id || option.value}
                                                                   container
                                                                   alignItems="center"
                                                                   spacing={1}>
                    <Grid flexGrow={1}>
                        <ButtonSelectWidgetItem onClick={onButtonClick}
                                                isSelected={value === option.value}
                                                value={option.value}
                                                label={option?.label} />
                    </Grid>
                    {(option.questionaire && value === option.value) && <Grid>
                        <IconButton onClick={() => onQuestionaireClick(option)}>
                            <PencilLineIcon color="black" />
                        </IconButton>
                    </Grid>}
                </Grid>)}
            </Stack>
            {widget.helperText && <FormHelperText>
                {widget.helperText}
            </FormHelperText>}
        </FormControl>
    )
}

ButtonSelectWidget.propTypes = {
    widget: PropTypes.object.isRequired,
    value: PropTypes.string,
    onValueChange: PropTypes.func.isRequired,
    triggerAction: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default ButtonSelectWidget
